export default __webpack_public_path__ + "static/media/Verified_Icon.d7a3f92d.svg";